import { EExternalRoutes } from "@core-types/routes.enum";
import { Link } from "react-router";
import Back from "./variants/Back";
import BackRounded from "./variants/BackRounded";
import Basic from "./variants/Basic";
import ButtonHelpBannerDiscord from "./variants/ButtonHelpBannerDiscord";
import JoinDiscord from "./variants/ButtonJoinDiscord";
import ButtonNavbar from "./variants/ButtonNavbar";
import ButtonNavbarResponsive from "./variants/ButtonNavbarResponsive";
import BuyNow from "./variants/BuyNow";
import Disabled from "./variants/Disabled";
import Gradient from "./variants/Gradient";
import ReadMore from "./variants/ReadMore";
import SeeMore from "./variants/SeeMore";

import useAppTranslation from "@hooks/language/useAppTranslation";
import ButtonActionIcon from "./variants/ButtonActionIcon";
import ButtonLiveChat from "./variants/ButtonLiveChat";

export const openDiscordProps = {
  component: Link,
  to: EExternalRoutes.DISCORD,
  target: "_blank",
  rel: "noreferrer noopener",
};

const ButtonVariants = {
  SeeMore,
  Discover: ({
    href,
    disabled,
    label,
  }: {
    href: string;
    disabled?: boolean;
    label?: string;
  }) => {
    const { t } = useAppTranslation("common.buttons");
    return (
      <Gradient
        isFullWidth
        disabled={disabled}
        href={href}
        label={label || t("discover")}
      />
    );
  },
  Navbar: ButtonNavbar,
  NavbarResponsive: ButtonNavbarResponsive,
  BuyNow,
  Gradient,
  JoinDiscord,
  HelpBanner: ButtonHelpBannerDiscord,
  LiveChat: ButtonLiveChat,
  Disabled,
  Basic,
  ReadMore,
  Back,
  BackRounded,
  ActionIcon: ButtonActionIcon,
};

export default ButtonVariants;
